import { useEffect } from 'react';
import { useShadowRoot } from '@backstage/plugin-techdocs-react';

const STYLE_ID = 'backstage-custom-styles';

export const CustomStyles = () => {
  const shadowRoot = useShadowRoot();

  useEffect(() => {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;

    fetch('/custom.css')
      .then(r => r.text())
      .then(css => {
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = css;
        shadowRoot.appendChild(style);
      });
  }, [shadowRoot]);

  return null;
};
